import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { Navigate, useNavigate, useParams } from 'react-router-dom';
import { slugify } from 'Utils/Functions';

const HomeRedirectCity = ({ children }) => {
  let { cityName } = useSelector((state) => state?.location);
  const navigate = useNavigate();
  const { city_name } = useParams();
  cityName = slugify(cityName);
  // console.log(cityName === city_name, cityName, cityName, city_name);

  useEffect(() => {
    navigate(`/${cityName}`);
  }, [cityName]);

  return cityName ? (
    <div>
      <>{children}</>
    </div>
  ) : (
    <Navigate to={`/`} />
  );
};

export default HomeRedirectCity;
